import React from 'react'
import { useSelector } from 'react-redux';

const ResetAllFilter = ({ handleFilterChange }) => {
    const lang = useSelector((state) => state.culture.language);

    return (
        <section className="ContentArea">
            <div className="  minHeight">
                <div className=" ">
                    <div className="no_result d-flex flex-column justify-content-center align-items-center mt-2">
                        <i className="no_result_package"></i>
                        <h4>{lang.no_result_found}</h4>
                        <p>
                            {lang.no_package_found_current_search}
                        </p>
                        <a
                            onClick={() => handleFilterChange('resetall')}
                            className="button_theme no_resultBtn"
                        >
                            {lang.flight_reset_all_filters}
                        </a>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ResetAllFilter